<template>
  <div id='app'>
    <div class="header">
      <h1>National Parks</h1>
      <div class="search-wrapper">
        <img class="search-icon" src="data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDU2Ljk2NiA1Ni45NjYiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDU2Ljk2NiA1Ni45NjY7IiB4bWw6c3BhY2U9InByZXNlcnZlIiB3aWR0aD0iMTZweCIgaGVpZ2h0PSIxNnB4Ij4KPHBhdGggZD0iTTU1LjE0Niw1MS44ODdMNDEuNTg4LDM3Ljc4NmMzLjQ4Ni00LjE0NCw1LjM5Ni05LjM1OCw1LjM5Ni0xNC43ODZjMC0xMi42ODItMTAuMzE4LTIzLTIzLTIzcy0yMywxMC4zMTgtMjMsMjMgIHMxMC4zMTgsMjMsMjMsMjNjNC43NjEsMCw5LjI5OC0xLjQzNiwxMy4xNzctNC4xNjJsMTMuNjYxLDE0LjIwOGMwLjU3MSwwLjU5MywxLjMzOSwwLjkyLDIuMTYyLDAuOTIgIGMwLjc3OSwwLDEuNTE4LTAuMjk3LDIuMDc5LTAuODM3QzU2LjI1NSw1NC45ODIsNTYuMjkzLDUzLjA4LDU1LjE0Niw1MS44ODd6IE0yMy45ODQsNmM5LjM3NCwwLDE3LDcuNjI2LDE3LDE3cy03LjYyNiwxNy0xNywxNyAgcy0xNy03LjYyNi0xNy0xN1MxNC42MSw2LDIzLjk4NCw2eiIgZmlsbD0iIzAwMDAwMCIvPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8L3N2Zz4K" />
        <input class="search" v-model="message" placeholder="Name or Location of park" type="text">
      </div>
      
    </div>

    <ul class='parks-container'>
      <ParkCard v-for='(park, index) in searchedParks' :key='index' :park='park' @clicked="moreInfo(park)" />
    </ul>
    <Modal v-show='modalToggle' :park='selectedPark' @close-modal='closeModal()'/>
  </div>
</template>

<script>

import ParkCard from './components/ParkCard';
import Modal from './components/Modal';

export default {
  name: 'app',
  components: { ParkCard, Modal },
  methods: {
    moreInfo(park) {
      this.selectedPark = park;
      this.openModal();
    },
    openModal() {
      this.modalToggle = true;
    },
    closeModal() {
      this.modalToggle = false;
    },
    getLocation(addressObj) {
      return addressObj.city + ', ' + addressObj.stateCode
    },
    getAddress(addressObj) {
      return [
        addressObj.line1 + ', ' + addressObj.line2,
        addressObj.city + ', ' + addressObj.stateCode + ', ' + addressObj.postalCode
      ]
    }
  },
  data () {
    return {
      parks: null,
      selectedPark: null,
      modalToggle: false,
      message: ''
    }
  },
  computed: {
    filteredParks() {
      if (!this.parks) return []
      else {
        return this.parks.filter(park => {
            return park.designation.toLowerCase().includes('national park')
          })
      }
    },
    mappedParks() {
      if (!this.filteredParks) return []
      else {
        return this.filteredParks.map( park => { return {
          ...park,
          location: this.getLocation(park.addresses[0]),
          image: park.images[0],
          address: this.getAddress(park.addresses[0])
        } }
        )
      }
    },
    searchedParks() {
      if (!this.message) {
        return this.mappedParks;
      }
      else {
        return this.mappedParks.filter(park => {
            return park.name.toLowerCase().includes(this.message.toLowerCase()) || park.location.toLowerCase().includes(this.message.toLowerCase())
          })
      }
    }
  },
  mounted () {
    const url = 'https://developer.nps.gov/api/v1/parks?q=National%20Park&limit=500&api_key=' + process.env.VUE_APP_API
    fetch(url)
      .then(res => res.json())
      .then(data => this.parks = data.data)
  }
}
</script>

<style lang='scss'>
html, body {
  margin: 0;
  padding: 0;
  font-size: 16px;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #373d39;
  padding: 1rem;
  background: #9eb5a8;
  min-height: 100vh;
}

h1, h2 {
  font-weight: normal;
}

p {
  margin: 7.5px 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
}

a {
  color: #42b970;
}

.search-wrapper {
  position: relative;
  display: flex;
  min-width: 100px;
  max-width: 480px;
  margin: auto;
}

.search {
  border: 1px solid #999;
  border-radius: 5px;
  height: 25px;
  width: 100%;
  padding: 2px 23px 2px 30px;
  outline: 0;
  background-color: #f5f5f5;
}

.search-icon {
  position: absolute;
  top: 8px;
  left: 8px;
  width: 14px;
}

.search:hover, .search:focus {
  border: 1px solid #373d39;
  background-color: white;
}

.parks-container {
  display: grid;
  justify-items: center;
  grid-template-columns: repeat(auto-fit, minmax(16rem, 1fr));
  grid-gap: 30px;
  margin: 30px;
}
</style>
